
export function generateUID() {
    // I generate the UID from two parts here
    // to ensure the random number provide enough bits.
    let firstNumber = (Math.random() * 46656) | 0;
    let secondNumber = (Math.random() * 46656) | 0;
    let firstPart = ("000" + firstNumber.toString(36)).slice(-3);
    let secondPart = ("000" + secondNumber.toString(36)).slice(-3);
    return firstPart + secondPart;
}
